export default class StepperUI {
    public valueElement: HTMLInputElement;
    public incrementButton: HTMLInputElement;
    public decrementButton: HTMLInputElement;

    constructor(public el: HTMLElement) {
        this.valueElement = this.el.queryRole<HTMLInputElement>('stepper-value');
        this.incrementButton = this.el.queryRole<HTMLInputElement>('button-increment');
        this.decrementButton = this.el.queryRole<HTMLInputElement>('button-decrement');
    }
}
